export const Categories = [
  { value: "general", label: "General" },
  { value: "business", label: "Business" },
  { value: "entertainment", label: "Entertainment" },
  { value: "health", label: "Health" },
  { value: "science", label: "Science" },
  { value: "sports", label: "Sports" },
  { value: "technology", label: "Technology" },
];

export const languages = [
  { value: "ar", label: "Arabic" },
  { value: "de", label: "German" },
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "he", label: "Hebrew" },
  { value: "it", label: "Italian" },
  { value: "nl", label: "Dutch" },
  { value: "no", label: "Norwegian" },
  { value: "pt", label: "Portuguese" },
  { value: "ru", label: "Russian" },
  { value: "sv", label: "Swedish" },
  { value: "ud", label: "Urdu" },
  { value: "zh", label: "Chinese" },
];

export const Countries = [
  { value: "ae", label: "United Arab Emirates" },
  { value: "ar", label: "Argentina" },
  { value: "at", label: "Austria" },
  { value: "au", label: "Australia" },
  { value: "be", label: "Belgium" },
  { value: "bg", label: "Bulgaria" },
  { value: "br", label: "Brazil" },
  { value: "ca", label: "Canada" },
  { value: "ch", label: "Switzerland" },
  { value: "cn", label: "China" },
  { value: "co", label: "Colombia" },
  { value: "cu", label: "Cuba" },
  { value: "cz", label: "Czech Republic" },
  { value: "de", label: "Germany" },
  { value: "eg", label: "Egypt" },
  { value: "fr", label: "France" },
  { value: "gb", label: "United Kingdom" },
  { value: "gr", label: "Greece" },
  { value: "hk", label: "Hong Kong" },
  { value: "hu", label: "Hungary" },
  { value: "id", label: "Indonesia" },
  { value: "ie", label: "Ireland" },
  { value: "il", label: "Israel" },
  { value: "in", label: "India" },
  { value: "it", label: "Italy" },
  { value: "jp", label: "Japan" },
  { value: "kr", label: "South Korea" },
  { value: "lt", label: "Lithuania" },
  { value: "lv", label: "Latvia" },
  { value: "ma", label: "Morocco" },
  { value: "mx", label: "Mexico" },
  { value: "my", label: "Malaysia" },
  { value: "ng", label: "Nigeria" },
  { value: "nl", label: "Netherlands" },
  { value: "no", label: "Norway" },
  { value: "nz", label: "New Zealand" },
  { value: "ph", label: "Philippines" },
  { value: "pl", label: "Poland" },
  { value: "pt", label: "Portugal" },
  { value: "ro", label: "Romania" },
  { value: "rs", label: "Serbia" },
  { value: "ru", label: "Russia" },
  { value: "sa", label: "Saudi Arabia" },
  { value: "se", label: "Sweden" },
  { value: "sg", label: "Singapore" },
  { value: "si", label: "Slovenia" },
  { value: "sk", label: "Slovakia" },
  { value: "th", label: "Thailand" },
  { value: "tr", label: "Turkey" },
  { value: "tw", label: "Taiwan" },
  { value: "ua", label: "Ukraine" },
  { value: "us", label: "United States" },
  { value: "ve", label: "Venezuela" },
  { value: "za", label: "South Africa" },
];

export const cardsData = [
  {
    url: "https://example.com/article1",
    urlToImage: "https://via.placeholder.com/300",
    author: "Author 1",
    title: "Article Title 1",
    description: "This is a short description of article 1.",
    publishedAt: "2025-01-01",
  },
  {
    url: "https://example.com/article2",
    urlToImage: "https://via.placeholder.com/300",
    author: "Author 2",
    title: "Article Title 2",
    description: "This is a short description of article 2.",
    publishedAt: "2025-01-02",
  },
  {
    url: "https://example.com/article3",
    urlToImage: "https://via.placeholder.com/300",
    author: "Author 3",
    title: "Article Title 3",
    description: "This is a short description of article 3.",
    publishedAt: "2025-01-03",
  },
  {
    url: "https://example.com/article4",
    urlToImage: "https://via.placeholder.com/300",
    author: "Author 4",
    title: "Article Title 4",
    description: "This is a short description of article 4.",
    publishedAt: "2025-01-04",
  },
];
